<div mat-dialog-content class="main-container aza-pa-dialog-content">
    <div class="aza-pa-flex-column">
        <div *ngIf="allTeams" class="header-container aza-pa-flex-column">
            <div class="header-line header-first-line aza-pa-flex-row">
                <azavista-input-field [field]="nameField" [value]="currentView.name" [editMode]="true"
                    [label]="'NAME' | translate" (valueChanged)="onViewNameChanged($event)"
                    placeholder="'NAME' | translate"></azavista-input-field>
                <mat-checkbox *ngIf="data.showUseViewInAllEvents" [(ngModel)]="data.useViewInAllEvents"
                    [disabled]="true">
                    <span translate>USE_VIEW_IN_ALL_EVENTS</span>
                </mat-checkbox>
                <mat-checkbox [(ngModel)]="currentView.shared_view" [disabled]="!isAdmin" color="primary">
                    <span translate>SHARE_VIEW_WITH_OTHER_USERS</span>
                </mat-checkbox>
            </div>
            <div *ngIf="currentView.shared_view" class="header-line header-second-line aza-pa-flex-row">
                <mat-checkbox [(ngModel)]="currentView.view_by_all" [disabled]="!isAdmin" color="primary">
                    <span translate>SHARE_VIEW_TO_ALL_TEAMS</span>
                </mat-checkbox>
                <div *ngIf="!currentView.view_by_all" class="teams-container aza-pa-flex-row">
                    <div class="aza-pa-flex-row aza-pa-no-gap">
                        <azavista-input-field [field]="teamField" [value]="teamFieldValue" [canEdit]="isAdmin"
                            [editMode]="isAdmin" [label]="'TEAM' | translate"
                            (valueChanged)="onTeamValueChanged($event)">
                        </azavista-input-field>
                        <button (click)="onAddTeamClicked()" [disabled]="!isAdmin" mat-icon-button>
                            <mat-icon >add</mat-icon>
                        </button>
                    </div>
                    <div *ngFor="let team of selectedTeams" class="selected-team-container aza-pa-flex-row aza-pa-no-gap">
                        <span>{{team.name}}</span>
                        <button (click)="onRemoveTeamClicked(team)" [disabled]="!isAdmin" mat-icon-button>
                            <mat-icon color="warn">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <span translate>LINK_THIS_VIEW_TO</span>
                </div>
                <div *ngFor="let fwav of filtersWithAvailableValues" class="aza-pa-flex-row">
                    <mat-form-field>
                        <mat-select (selectionChange)="onMultiSelectFieldChanged($event, fwav)"
                            [(value)]="fwav.filter.field_name" placeholder="{{'FIELD' | translate}}">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let field of selectAndMultiSelectFields" [value]="field.id">
                                {{field.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select [(value)]="fwav.filter.values" multiple placeholder="{{'VALUE' | translate}}">
                            <mat-option *ngFor="let value of fwav.availableValues" [value]="value">
                                {{value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="sectionGroups"
        class="sections-and-fields-container aza-pa-two-columns-grid aza-pa-two-columns-grid-full-width-columns">
        <div cdkDropList [cdkDropListData]="sectionGroups"
            class="sections-container aza-pa-flex-column aza-pa-half-padding mat-elevation-z1"
            (cdkDropListDropped)="onSectionDropped($event)">
            <div *ngFor="let sectionGroup of sectionGroups; index as sectionIndex" class="section mat-elevation-z1"
                cdkDrag>
                <div class="section-header aza-pa-grid">
                    <div class="aza-pa-flex-row">
                        <mat-icon class="grabbable">drag_handle</mat-icon>
                        <input [(ngModel)]="sectionGroup.label" matInput placeholder="{{'NAME' | translate}}" />
                    </div>
                    <div>
                        <mat-checkbox [(ngModel)]="sectionGroup.readonly" color="primary"><span
                                translate>READ_ONLY</span></mat-checkbox>
                    </div>
                    <div>
                        <button (click)="onSectionDeleted(sectionGroup)" mat-icon-button color="warn">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="section-columns aza-pa-grid aza-pa-two-columns-grid-full-width-columns aza-pa-flex-item-align-normal">
                    <div cdkDropList [cdkDropListData]="sectionGroup.leftFields"
                        [id]="'section-' + sectionIndex + '-left-fields'" [cdkDropListConnectedTo]="connectedDropLists"
                        (cdkDropListDropped)="onFieldDropped($event)" class="section-column">
                        <div *ngFor="let field of sectionGroup.leftFields" cdkDrag class="field aza-pa-padding mat-elevation-z1">
                            {{field.label}}</div>
                    </div>
                    <div cdkDropList [cdkDropListData]="sectionGroup.rightFields"
                        [id]="'section-' + sectionIndex + '-right-fields'" [cdkDropListConnectedTo]="connectedDropLists"
                        (cdkDropListDropped)="onFieldDropped($event)" class="section-column">
                        <div *ngFor="let field of sectionGroup.rightFields" cdkDrag class="field aza-pa-padding mat-elevation-z1">
                            {{field.label}}</div>
                    </div>
                </div>
            </div>
            <div class="sections-actions aza-pa-flex-row aza-pa-content-center">
                <button (click)="onNewSectionAdded()" mat-mini-fab color="primary">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <div class="fields-container aza-pa-half-padding mat-elevation-z1">
            <div>
                <mat-form-field>
                    <input [(ngModel)]="searchText" matInput placeholder="{{'QUICK_SEARCH' | translate}}" />
                </mat-form-field>
            </div>
            <div cdkDropList [cdkDropListData]="availableFields" id="available-fields-list"
                [cdkDropListConnectedTo]="connectedDropLists" (cdkDropListDropped)="onFieldDropped($event)"
                class="available-fields-list">
                <ng-container *ngFor="let field of availableFields">
                    <div cdkDrag
                        [ngClass]="{'has-filter': !!searchText, 'filtered-by-filter': shouldFilterByFilter(field)}"
                        class="field aza-pa-padding mat-elevation-z1">
                        {{field.label}}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="aza-pa-dialog-actions">
    <azavista-button (click)="onClose()" class="aza-pa-dialog-action-cancel-button"><span
            translate>CANCEL</span></azavista-button>
    <azavista-button (click)="onDelete()" [disabled]="!currentView?.id" class="aza-pa-dialog-action-cancel-button"
        color="warn"><span translate>DELETE</span></azavista-button>
    <azavista-button (click)="onSave()" [disabled]="!canSave" color="primary" class="aza-pa-dialog-action-apply-button">
        <span translate>SAVE</span>
    </azavista-button>
</div>
